const showAuthInputs = function () {
  const authTypeSelect = $('#webhook_endpoint_authentication_type');
  if (authTypeSelect.val() === 'no_auth') {
    $('.js-webhook-basic-auth, .js-webhook-token-auth').hide();
  } else if (authTypeSelect.val() === 'basic') {
    $('.js-webhook-token-auth').hide();
    $('.js-webhook-basic-auth').show();
  } else {
    $('.js-webhook-basic-auth').hide();
    $('.js-webhook-token-auth').show();
  }
};

document.addEventListener('turbolinks:load', function () {
  showAuthInputs();
  $('#webhook_endpoint_authentication_type').on('change', showAuthInputs);
});
